export default {
  container: {
    display: "inline-flex",
    alignItems: "center",
    "@media print": {
      fontSize: "10pt",
      fontWeight: 600,
    }
  },
};
